module.exports = __webpack_public_path__ + "img/vietnam.b7fa9922.svg";